// Seal-tag codes vary by supplier: most QR/data-matrix security seals encode
// the bare serial printed on the tag, but some encode a URL that ends in it.
// Either way the seal number is the last meaningful token. Mirrored in
// mobile/src/helpers/sealScan.js - keep the two in step.
export const parseSealScan = (text) => {
  const trimmed = String(text ?? '').trim()
  if (!trimmed) return ''
  if (/^https?:\/\//i.test(trimmed)) {
    try {
      const segments = new URL(trimmed).pathname.split('/').filter(Boolean)
      return segments[segments.length - 1] ?? trimmed
    } catch {
      return trimmed
    }
  }
  return trimmed
}

// Seal comparison is forgiving about case and stray whitespace - the printed
// serial is what matters, not how it was transcribed when the bag was sealed.
export const sealsMatch = (a, b) =>
  parseSealScan(a).toUpperCase() === parseSealScan(b).toUpperCase() &&
  parseSealScan(a) !== ''
